import React from 'react';

type Props = {
  width?: number | string;
  height?: number | string;
  color?: string;
  active?: boolean;
  hover?: boolean;
};

const DownStackedArrow: React.FC<Props> = ({
  width = 16,
  height = 16,
  color = '#cccddb',
  active = false,
  hover = false,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 10.979 16"
    >
      <g transform="scale(1, -1) translate(0, -16)">
        <path
          d="M0,4.57,4.605,0,9,4.716"
          transform="translate(0.99 11.006)"
          fill="none"
          stroke={active && hover ? '#9898E2' : color}
          strokeLinecap="round"
          strokeWidth="1.4"
        />
        <path
          d="M0,4.57,4.605,0,9,4.716"
          transform="translate(0.99 6.006)"
          fill="none"
          stroke={active && hover ? '#CECDEB' : color}
          strokeLinecap="round"
          strokeWidth="1.4"
        />
        <path
          d="M0,4.57,4.605,0,9,4.716"
          transform="translate(0.99 1.006)"
          fill="none"
          stroke={active ? (hover ? '#FFFFFF' : '#151740') : color}
          strokeLinecap="round"
          strokeWidth="1.4"
        />
      </g>
    </svg>
  );
};

export default DownStackedArrow;
